{
  "collect": "เก็บสิ่งส่งตรวจ",
  "track": "ติดตามสิ่งส่งตรวจ",
  "accession": "เลขที่รับตัวอย่าง",
  "barcode": "บาร์โค้ด",
  "status": {
    "ordered": "สั่งตรวจแล้ว",
    "collected": "เก็บแล้ว",
    "inTransit": "กำลังขนส่ง",
    "received": "รับแล้ว",
    "processing": "กำลังตรวจวิเคราะห์",
    "resulted": "ออกผลแล้ว",
    "rejected": "Rejected",
    "in_transit": "กำลังขนส่ง"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
